import React from 'react';
import { Wifi, WifiOff } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../components/ui/tooltip';

export const WebSocketIndicator = ({ isConnected }) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div 
            className={`flex items-center gap-1.5 px-2 py-1 rounded-full text-xs font-medium transition-colors ${
              isConnected 
                ? 'bg-green-100 text-green-700' 
                : 'bg-slate-100 text-slate-500'
            }`}
            data-testid="ws-indicator"
          >
            {isConnected ? (
              <>
                <Wifi size={12} />
                <span className="hidden sm:inline">En vivo</span>
              </>
            ) : (
              <>
                <WifiOff size={12} />
                <span className="hidden sm:inline">Desconectado</span>
              </>
            )}
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            {isConnected 
              ? 'Notificaciones en tiempo real activas' 
              : 'Reconectando notificaciones...'}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default WebSocketIndicator;
